
      import {$emit} from 'uni-platform/service/api/base/event-bus.js'
import {$on} from 'uni-platform/service/api/base/event-bus.js'
import {addInterceptor} from 'uni-core/service/api/base/interceptor.js'
import {arrayBufferToBase64} from 'uni-core/service/api/base/base64.js'
import {base64ToArrayBuffer} from 'uni-core/service/api/base/base64.js'
import {canIUse} from 'uni-core/service/api/base/can-i-use.js'
import {canvasToTempFilePath} from 'uni-core/service/api/context/canvas.js'
import {chooseFile} from 'uni-platform/service/api/media/choose-file.js'
import {chooseImage} from 'uni-platform/service/api/media/choose-image.js'
import {chooseVideo} from 'uni-platform/service/api/media/choose-video.js'
import {clearStorageSync} from 'uni-platform/service/api/storage/storage.js'
import {connectSocket} from 'uni-platform/service/api/network/socket.js'
import {createCanvasContext} from 'uni-core/service/api/context/canvas.js'
import {createIntersectionObserver} from 'uni-core/service/api/ui/create-intersection-observer.js'
import {createMediaQueryObserver} from 'uni-core/service/api/ui/create-media-query-observer.js'
import {createSelectorQuery} from 'uni-core/service/api/ui/create-selector-query.js'
import {downloadFile} from 'uni-platform/service/api/network/download-file.js'
import {getLaunchOptionsSync} from 'uni-platform/service/api/plugin/get-launch-options-sync.js'
import {getLocale} from 'uni-core/service/api/ui/locale.js'
import {getPushClientId} from 'uni-core/service/api/plugin/push.js'
import {getStorageInfoSync} from 'uni-platform/service/api/storage/storage.js'
import {getStorageSync} from 'uni-platform/service/api/storage/storage.js'
import {getSystemInfo} from 'uni-platform/service/api/device/get-system-info.js'
import {getSystemInfoSync} from 'uni-platform/service/api/device/get-system-info.js'
import {hideLoading} from 'uni-platform/service/api/ui/popup.js'
import {navigateBack} from 'uni-platform/service/api/route/route.js'
import {navigateTo} from 'uni-platform/service/api/route/route.js'
import {offPushMessage} from 'uni-core/service/api/plugin/push.js'
import {offWindowResize} from 'uni-platform/service/api/ui/window.js'
import {onPushMessage} from 'uni-core/service/api/plugin/push.js'
import {onWindowResize} from 'uni-platform/service/api/ui/window.js'
import {reLaunch} from 'uni-platform/service/api/route/route.js'
import {redirectTo} from 'uni-platform/service/api/route/route.js'
import {removeStorageSync} from 'uni-platform/service/api/storage/storage.js'
import {request} from 'uni-platform/service/api/network/request.js'
import {setClipboardData} from 'uni-platform/service/api/device/clipboard.js'
import {setNavigationBarColor} from 'uni-platform/service/api/ui/navigation-bar.js'
import {setStorageSync} from 'uni-platform/service/api/storage/storage.js'
import {showLoading} from 'uni-platform/service/api/ui/popup.js'
import {showModal} from 'uni-platform/service/api/ui/popup.js'
import {showToast} from 'uni-platform/service/api/ui/popup.js'
import {switchTab} from 'uni-platform/service/api/route/route.js'
import {uploadFile} from 'uni-platform/service/api/network/upload-file.js'
import {upx2px} from 'uni-core/service/api/base/upx2px.js'
      export default {
        $emit,
$on,
addInterceptor,
arrayBufferToBase64,
base64ToArrayBuffer,
canIUse,
canvasToTempFilePath,
chooseFile,
chooseImage,
chooseVideo,
clearStorageSync,
connectSocket,
createCanvasContext,
createIntersectionObserver,
createMediaQueryObserver,
createSelectorQuery,
downloadFile,
getLaunchOptionsSync,
getLocale,
getPushClientId,
getStorageInfoSync,
getStorageSync,
getSystemInfo,
getSystemInfoSync,
hideLoading,
navigateBack,
navigateTo,
offPushMessage,
offWindowResize,
onPushMessage,
onWindowResize,
reLaunch,
redirectTo,
removeStorageSync,
request,
setClipboardData,
setNavigationBarColor,
setStorageSync,
showLoading,
showModal,
showToast,
switchTab,
uploadFile,
upx2px
      }
      